module.exports = __webpack_public_path__ + "228642bc4da1eac5a6ca15f7506a5a2c.pdf";